// ОБЩЕЕ

// Протоколы
export const HTTP = 'http://';
export const HTTPS = 'https://';

// Порты
export const PORT_3000 = process.env.REACT_APP_HOST_NUMBER || 3000;

// Домены и поддомены
export const DOMAIN_LOCALHOST = 'localhost';
export const DOMAIN_BY_HELP = 'byhelp';
export const SUBDOMAIN_DEV = 'dev';

// Доменные зоны
export const ZONE_RU = 'ru';
export const ZONE_IO = 'io';
export const ZONE_ONLINE = 'online';
export const ZONE_COM = 'com';

// Хосты (режим разработки)
export const HOST_LOCALHOST_3000 = `${DOMAIN_LOCALHOST}:${PORT_3000}`;
export const HOST_DEV_BY_HELP_RU = `${SUBDOMAIN_DEV}.${DOMAIN_BY_HELP}.${ZONE_RU}`;

// Хосты (режим продакшена)
export const HOST_BY_HELP_RU = `${DOMAIN_BY_HELP}.${ZONE_RU}`;
export const HOST_BY_HELP_IO = `${DOMAIN_BY_HELP}.${ZONE_IO}`;
export const HOST_BY_HELP_ONLINE = `${DOMAIN_BY_HELP}.${ZONE_ONLINE}`;
export const HOST_BY_HELP_COM = `${DOMAIN_BY_HELP}.${ZONE_COM}`;

// API-постфикс
export const API = '/api';

// РЕСУРСЫ
export const AUTHENTICATION_CHUNK = '/Authentication';
export const AUTHENTICATION = AUTHENTICATION_CHUNK;
export const USERS_CHUNK = '/Users';
export const USERS_RESOURCE = USERS_CHUNK;
export const USER_CHUNK = '/User';
export const USER_RESOURCE = '/User';
export const USER = USER_CHUNK;
export const CHAINS_CHUNK = '/Chains';
export const BRANCHES_CHUNK = '/Branches';
export const CLIENTS_CHUNK = '/Clients';
export const CLIENT_CHUNK = '/Client';
export const CLIENT = CLIENT_CHUNK;
export const ACCESS_RIGHTS_CHUNK = '/AccessRights';
export const ACCESS_RIGHTS = ACCESS_RIGHTS_CHUNK;
export const TAGS_CHUNK = '/Tags';
export const NOTIFICATIONS_CHUNK = '/Notifications';
export const CLIENT_FIELDS_CHUNK = '/ClientFields';
export const SUBSCRIPTIONS_CHUNK = '/Subscriptions';
export const CERTIFICATES_CHUNK = '/Certificates';
export const POSITIONS_CHUNK = '/Positions';
export const CLIENT_SERVICES_CHUNK = '/ClientServices';
export const ACTION_HISTORY_CHUNK = '/ActionsHistory';
export const RECORDS_RESOURCE = '/Records';
export const WORK_SCHEDULE_CHINK = '/WorkSchedule';
export const WORK_SCHEDULE = '/WorkSchedule';
export const LEGAL_ENTITIES = '/LegalEntities';
export const CLIENT_FILES = '/ClientFiles';
export const PAYMENT_ACCOUNTS = '/PaymentAccounts';
export const SOCIAL_INTEGRATIONS = '/SocialIntegrations';
export const INTEGRATION_AUTH = '/IntegrationAuth';
export const ATC_BEELINE_CHUNK = 'AtcBeeline';
export const ATC_MANGO_CHUNK = 'AtcMango';
export const CLIENT_PAYMENTS_RESOURCE = '/ClientPayments';
export const EXPENSE_ARTICLES = '/ExpenseArticles';
export const MONEY_EXPENSES = '/MoneyExpenses';
export const SALE_PLANS_CHUNK = '/SalePlans';
export const MIGRATION_CHUNK = '/Migration';
export const MIGRATION = MIGRATION_CHUNK;
export const USER_FILE_REQUESTS_CHUNK = '/UserFileRequests';
export const USER_FILE_REQUESTS = USER_FILE_REQUESTS_CHUNK;
export const LEADS_CHUNK = '/Leads';
export const LEADS_RESOURCE = LEADS_CHUNK;
export const EMPLOYEES_CHUNK = '/Employees';
export const EMPLOYEES_RESOURCE = EMPLOYEES_CHUNK;
export const SALES_FUNNELS_CHUNK = '/SalesFunnels';
export const SALES_FUNNELS_STAGES_CHUNK = '/SalesFunnels/Stages';
export const SALES_FUNNELS_STAGES_RESOURCE = SALES_FUNNELS_STAGES_CHUNK;
export const SALES_FUNNELS_STAGES_ROBOTS_CHUNK = '/SalesFunnels/Stages/Robots';
export const ORGANIZATION_CHUNK = '/Organization';
export const ORGANIZATION_RESOURCE = ORGANIZATION_CHUNK;
export const DADATA_CHUNK = '/DaData';
export const ORGANIZATIONS_CHUNK = '/Organizations';
export const ORGANIZATIONS_RESOURCE = ORGANIZATION_CHUNK;
export const TEMPLATES_CHUNK = '/Templates';
export const TEMPLATES_RESOURCE = TEMPLATES_CHUNK;
export const SENDOUTS_CHUNK = '/Sendouts';
export const SENDOUTS_RESOURCE = SENDOUTS_CHUNK;
export const RESOURCES_MESSAGE_TEMPLATES = '/MessageTemplates';
export const RECORD_REMINDERS = '/RecordReminders';
export const WAREHOUSES_RESOURCE = '/Warehouses';
export const PRODUCTS_RESOURCE = '/Products';
export const EMPLOYEE_SALARY_RESOURCE = '/EmployeeSalary';
export const WAREHOUSES_INVENTOSIES_RESOURCE = '/WarehouseInventories';
export const SOCIAL_INTEGRATION_EMAIL_PARSING_RULE =
  '/SocialIntegrationEmailParsingRule';
export const AI_OPERATOR_CONFIG = '/AiOperatorConfig';
// Внешний сервис лояльности (book-host), v1 — версия его собственного API.
export const EXTERNAL_LOYALTY_CHUNK = '/external-loyalty/v1';
export const TECHNOLOGICAL_MAPS = '/TechnologicalMaps';
export const LOYALTY_RESOURCE = '/Loyalty';
export const CLIENTS_MERGE_CHUNK = '/ClientsMerge';
export const SIDEBAR_CHUNK = 'Sidebar';
export const MEDICAL_DOCUMENTS_CHUNK = '/MedicalDocuments';

// СЕРВЕРНЫЕ МЕТОДЫ

// Общие
export const CREATE = 'Create';

// Leads
export const GET_CLIENT_USERNAMES = 'GetClientUsernames';
export const SET_CLIENT_USERNAMES = 'SetClientUsernames';

// SalesFunnels
export const LIST_FOR_FILTERS = 'ListForFilters';
export const GET_GLOBAL_FILTER_FUNNELS = 'GetGlobalFilterFunnels';
export const CRM_TASKS = 'CrmTasks';

// AccessRights
export const UPDATE_ACCESS_RIGHTS_MODULES = 'UpdateAccessRightsModules';

// ErrorReports
export const ERROR_REPORTS = 'ErrorReports';

// RecordReminders
export const GET_RECORD_REMINDERS = 'GetRecordReminders';
export const SET_RECORD_REMINDERS = 'SetRecordReminders';

// ЭНДПОИНТЫ

// Authentication
export const AUTHENTICATE_BY_EMAIL_ACCESS_CODE_ENDPOINT = `${AUTHENTICATION}/AuthenticateByEmailAccessCode`;
export const AUTHENTICATE_BY_COOKIE_ENDPOINT = `${AUTHENTICATION}/AuthenticateByCookie`;
export const DECRYPT_EMAIL_COOKIE_ENDPOINT = `${AUTHENTICATION_CHUNK}/DecryptEmailCookie`;

// Dictionaries
export const DICTIONARIES_CHUNK = '/Dictionaries';
export const DICTIONARIES_RESOURCE = DICTIONARIES_CHUNK;
export const GET_USED_COUNTRIES_ENDPOINT = `${DICTIONARIES_CHUNK}/GetUsedCountries`;
export const GET_USED_CITIES_ENDPOINT = `${DICTIONARIES_CHUNK}/GetUsedCities`;
export const GET_COUNTRIES_ENDPOINT = `${DICTIONARIES_CHUNK}/GetCountries`;
export const GET_CLIENT_LANGUAGES_ENDPOINT = `${DICTIONARIES_CHUNK}/GetClientLanguages`;

// Timezones
export const TIMEZONE_CHUNK = '/Timezones';

// AccessRights

// ClientServices

// ActionsHistory
export const GET_USER_ACTION_HISTORY_ENDPOINT = `${ACTION_HISTORY_CHUNK}/GetUserActionHistory`;
export const GET_CLIENT_ACTION_HISTORY_ENDPOINT = `${ACTION_HISTORY_CHUNK}/GetClientActionHistory`;
export const GET_LEAD_CLIENT_ACTION_HISTORY_ENDPOINT = `${ACTION_HISTORY_CHUNK}/GetLeadClientActionHistory`;
export const GET_RECORD_ACTION_HISTORY_ENDPOINT = `${ACTION_HISTORY_CHUNK}/GetRecordActionHistory`;

// Records
export const GET_CLIENT_RECORDS = `${RECORDS_RESOURCE}/GetClientRecords`;

// WorkSchedule
export const GET_SCHEDULES_AND_RECORDS_ENDPOINT = `${WORK_SCHEDULE}/GetEmployeesWorkSchedulesWithRecords`;

// PaymentAccounts

// SocialIntegrations
export const CHANGE_INTEGRATION_NAME_ENDPOINT = `${SOCIAL_INTEGRATIONS}/ChangeIntegrationName`;

// ClientPayments
export const PAY_RECORD_FULLY = `${CLIENT_PAYMENTS_RESOURCE}/PayRecordsFully`;

// ExpenseArticles

// UserFileRequests

// Templates (импорт клиентов)
export const GET_CLIENTS_IMPORT_TEMPLATE_ENDPOINT = `${TEMPLATES_RESOURCE}/ByHelp-Clients-Import.xlsx`;

// Templates (импорт записей)
export const GET_RECORDS_IMPORT_TEMPLATE_ENDPOINT = `${TEMPLATES_RESOURCE}/ByHelp-Records-Import.xlsx`;

// Templates (импорт услуг)
export const GET_SERVICES_IMPORT_TEMPLATE_ENDPOINT = `${TEMPLATES_RESOURCE}/ByHelp-Services-Import.xlsx`;

// Templates (импорт исполнителей)
export const GET_USERS_IMPORT_TEMPLATE_ENDPOINT = `${TEMPLATES_RESOURCE}/ByHelp-Users-Import.xlsx`;

// Templates (импорт товаров)
export const GET_PRODUCTS_IMPORT_TEMPLATE_ENDPOINT = `${TEMPLATES_RESOURCE}/ByHelp-Products-Import.xlsx`;

// Sendouts
export const GET_SENDOUT_BY_ID = 'GetSendoutById';
export const GET_SENDOUTS = 'GetSendouts';
export const PREPARE_SENDOUT_CREATION = 'PrepareSendoutCreation';
export const CREATE_SENDOUT = 'CreateSendout';
export const START_SENDOUT = 'StartSendout';
export const STOP_SENDOUT = 'StopSendout';
export const GET_SENDOUT_FILTER_DATA = 'GetSendoutFilterData';
export const PREVIEW_SENDOUT_MESSAGE = 'PreviewSendoutMessages';
export const GET_SENDOUT_DETAILS = 'GetSendoutDetails';
export const GET_SENDOUT_CLIENTS = 'GetSendoutClients';
export const GET_SENDOUT_KEYWORDS = 'GetSendoutKeywords';

// RecordReminders
export const GET_RECORD_REMINDERS_ENDPOINT = `${RECORD_REMINDERS}/${GET_RECORD_REMINDERS}`;
export const SET_RECORD_REMINDERS_ENDPOINT = `${RECORD_REMINDERS}/${SET_RECORD_REMINDERS}`;
